import { apiRequest } from '@/utils/apiRequest'
import { apiUrl } from '@/utils/apiUrl'

class TranslationRepository {
	constructor() {
		const host = window.location.hostname
		if (host === 'localhost' || host.startsWith('192.168')) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL
		} else {
			this.urlBase = window.location.origin
		}
	}

	async getTranslations(data) {
		const response = await apiRequest({ url: apiUrl('/world/api/translations/get'), method: 'POST', body: data, token: null, throwOnNonOk: false })
		if (!response.ok) return response.status
		return response.data
	}
}

export const translationRepository = new TranslationRepository()
